import moment from "moment";
import {
  setUser,
  getUser,
  clearUser,
  setToken,
  getToken,
  clearToken,
  updateUser,
} from "./sessionHelper";
import Utility from "./utilityHelper";
import SweetAlert from "./sweetAlert";
import AppConstant from "../constants/appConstant";
import ApiService from "../services/HttpServiceManager";
import { ImageConstant } from "../constants/imageConstant";
import { toast } from "../components/ui/use-toast";
import AntDesignMessage from "../components/antdesignMessage/antdesignMessage";
import AntDesignModal from "../components/antdesignModal/antdesignModal";

const delay = (milliseconds = 500) =>
  new Promise((res) => setTimeout(res, milliseconds));

const showToast = (message, title = "Error", type = "destructive") =>
  toast({
    title: title,
    description: <>{message}</>,
    color: type,
  });

export default {
  AppConstant,
  moment,
  ApiService,
  setUser,
  getUser,
  clearUser,
  setToken,
  getToken,
  clearToken,
  updateUser,
  Utility,
  delay,
  SweetAlert,
  showToast,
  ImageConstant,
  AntDesignMessage,
  AntDesignModal,
};
